
<header class="t-relative">
  <div :class="['c-header', { '-responsive': isResponsive }]">
    <div class="o-container t-full t-fill">
      <div class="o-grid -xs-middle t-full">
        <div class="o-grid__item -xs-10 t-lg-hide">
          <div class="c-header__slot">
            <vResponsiveCategoryMenu :category-tree="categoryTree" />
          </div>
        </div>

        <div class="o-grid__item -xs-4 -lg-shrink t-text-center">
          <a
            href="/"
            aria-label="ir para a página inicial"
          >
            <div class="o-logo">
              <vIcon
                name="logo"
                size="medium"
              />
            </div>
          </a>
        </div>

        <div
          class="o-grid__item -xs-24 -xs-last -lg-initial-order -lg-grow"
          :class="{ 't-xs-hide t-lg-block': !shouldShowMobileSearch }"
        >
          <vSearch
            :initial-context="initialSearchContext"
            :placeholder-complements="placeholderComplements"
            :should-auto-focus-on-desktop="shouldAutoFocusOnDesktop"
          />
        </div>

        <div class="o-grid__item -xs-10 -lg-shrink t-text-right">
          <vNavigation
            :departments="departments"
            :opened-panel-index="openedPanelIndex"
            @open-panel="setNavigationPanel"
          />
        </div>
      </div>
    </div>
  </div>

  <vNavigationPanel
    v-if="isLargeDesktop"
    :category-tree="categoryTree"
    :columns="departments"
    :opened-panel-index="openedPanelIndex"
    @mouse-leave-content="setNavigationPanel(null)"
    @mouse-enter-content="onMouseEnterContent"
  />

  <vSearchHighlightsPanel
    v-if="isLargeDesktop"
    :initial-context="initialSearchContext"
  />
</header>
